import Ract from 'react';
import { styled } from '@mui/material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import HeaderImage from  '../Images/Header Image.png';
import Link from '@mui/material/Link';
import '../style.css';
import { useNavigate } from 'react-router';


const H1 = styled(Typography)((theme)=>({
    fontFamily: 'Outfit',
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "56px;",
    lineHeight: "110%",
    letterSpacing: "-0.01em;",
    color: "#000000;"
    }))
    
    
    const H2 = styled(Typography)((theme)=>({
    fontFamily: 'Outfit',
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "40px",
    lineHeight: "125%",
    letterSpacing: "0.01em",
    color: "#1A1824"
    
    }))
    
    const H3 = styled(Typography)(({theme})=>({
        fontFamily: 'Outfit',
        fontStyle: "normal",
        fontWeight: "600",
        fontSize: "24px",
        lineHeight: "150%",
        letterSpacing: "0.01em",
        color: "#1A1824"
    }))
    
    const H4 = styled(Typography)(({theme})=>({
        fontFamily: 'Outfit',
        fontStyle: "normal",
        fontWeight: "600",
        fontSize: "20px",
        lineHeight: "150%",
        letterSpacing: "0.01em",
        color: "#1A1824"
    }))
    
    const P = styled(Typography)(({theme})=>({
        fontFamily: 'Outfit',
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "150%",
        letterSpacing: "0.01em",
        color: "#1A1824"
    }))
    const Btn = styled(Button)(({theme})=>({
        padding: '5px 20px;',
        border: '1px solid #559A95;',
       backgroundColor:"#2B817B",
        fontSize: '20px;',
        fontWeight: '600',
        borderRadius: "8px;",
        color:'white'
    
    }))


    function GrowBussniess(){
        let navigate = useNavigate();
        return(
            <>
            <Container maxWidth="lg" sx={{backgroundColor:"#F0FAF9",padding:'64px 0px',borderRadius:'12px'}}>
                <H2 sx={{fontSize:{lg:'40px',md:'30px',sm:'20px',xs:'20px',textAlign:'center'}}}>Let’s Grow your business with EatCoast</H2>
                <P sx={{fontSize:{lg:'18px',md:'18px',sm:'14px',xs:'14px',textAlign:'center'}}}>Come partner with us for flexibility in earning your own income.<br/>
                Find out the requirements and how to register here.</P>
                <center>
                {/* <Btn sx={{height:'60px', width:{lg:'340px',md:'340px',sm:'300px',xs:'280px'}, fontSize:{lg: '20px',md:"20px",sm:'14px',xs:'14px'}, marginTop:5}}>Become a Delivery Deriver</Btn> */}
                <Button variant="contained" size="large" sx={{
                    textTransform:'capitalize',
                    mt:'10px'
                }} onClick={()=> navigate('/registerdriver')}>Become a Delivery Deriver</Button>
                <Link sx={{display:'block',marginTop:3,fontSize:{lg:'18px',md:'18px',sm:'16px',xs:'16px'}}} href="#">See requirements to become a caterer</Link>
                    
                </center>

            </Container>
            </>
        )

    }

    export default GrowBussniess